module.exports = __webpack_public_path__ + "img/two-stars.fe07c1de.svg";